import React from 'react';

import styles from './ColorControlsModal.scss';

export const PointerCircle = () => {
  return <div className={styles.pointerCircle} />;
};
